// extracted by mini-css-extract-plugin
export var body = "_q2-8";
export var button = "_q2-0";
export var closeButton = "_q2-5";
export var content = "_q2-3";
export var empty = "_q2-f";
export var grid = "_q2-c";
export var header = "_q2-4";
export var icon = "_q2-1";
export var option = "_q2-d";
export var optionSelected = "_q2-e";
export var overlay = "_q2-2";
export var searchIcon = "_q2-a";
export var searchInput = "_q2-b";
export var searchWrapper = "_q2-9";
export var title = "_q2-6";
export var visuallyHidden = "_q2-7";